import React from "react";

const LazyBoards = React.lazy(() => import("./Boards").then((m) => ({ default: m.Boards })));

export default LazyBoards;
